import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useMutation } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import { FileText } from "lucide-react";

export default function EULAAcceptance() {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const [hasAccepted, setHasAccepted] = useState(false);

  useEffect(() => { loadUser(); }, []);

  const loadUser = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) { navigate("/Auth"); return; }
    const { data: profile } = await supabase.from("profiles").select("*").eq("id", session.user.id).single();
    setCurrentUser(profile);
    if (profile.has_accepted_eula) navigate("/Discover");
  };

  const acceptMutation = useMutation({
    mutationFn: async () => {
      const { error } = await supabase.from("profiles").update({ has_accepted_eula: true }).eq("id", currentUser.id);
      if (error) throw error;
    },
    onSuccess: () => { toast.success("EULA accepted"); navigate("/Discover"); },
    onError: () => { toast.error("Failed to accept EULA"); },
  });

  if (!currentUser) return <div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div></div>;

  return (
    <div className="min-h-screen p-8 flex items-center justify-center">
      <div className="max-w-4xl w-full bg-card p-8 rounded-lg border border-border">
        <div className="flex items-center gap-3 mb-6"><FileText className="w-8 h-8 text-primary" /><h1 className="text-3xl font-bold text-card-foreground">End User License Agreement</h1></div>
        <div className="bg-muted/50 p-6 rounded max-h-96 overflow-y-auto mb-6"><p className="text-muted-foreground">By accessing and using this platform, you accept and agree to be bound by the terms of this agreement.</p></div>
        <div className="flex items-center space-x-2 mb-6"><Checkbox id="accept" checked={hasAccepted} onCheckedChange={setHasAccepted} /><label htmlFor="accept" className="text-sm font-medium">I have read and accept the EULA</label></div>
        <div className="flex gap-4"><Button onClick={() => { if (!hasAccepted) { toast.error("Please check the box"); return; } acceptMutation.mutate(); }} className="flex-1" disabled={!hasAccepted || acceptMutation.isPending}>{acceptMutation.isPending ? "Accepting..." : "Accept and Continue"}</Button><Button variant="outline" onClick={() => navigate("/EULA")}>Read Full EULA</Button></div>
      </div>
    </div>
  );
}